/* eslint-disable */
/* THIS FILE WAS GENERATED BY THE WEB TRACKING CODGEN TOOL.  DO NOT MODIFY. */
import { createTracker, type HostWebTracker, type MFEWebTracker } from '@bdc-libs/matrix.web-tracking';

interface Page_Viewed_EventProperties {
    category?: string;
    name: string;
    path?: string;
    referrer?: string;
    search?: string;
    title?: string;
    url?: string;
}

interface beep_experiment_assigned_EventProperties {
    apex_org_id: string;
    behavior_name: string;
    bucketing_key: string;
    bucketing_type: string;
    control?: boolean;
    error_message?: string;
    experiment_env: 'appstage' | 'apptest' | 'dev' | 'local' | 'prod';
    experiment_name?: string;
    input_attributes: string;
    is_child_org: boolean;
    placement: string;
    variation_comment: string;
    variation_label: string;
}

interface se_signup__add_person__fired_EventProperties {
    person_type: 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__add_person_drawer_cancelled__fired_EventProperties {
    person_type: 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__add_person_drawer_saved__fired_EventProperties {
    person_type: 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_business_info_address_mail_address_same_as_biz_address__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_mailing_address_stree__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_mailing_address_street__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_mailing_address_street_additional__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_mailing_state__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_mailing_zip__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_physical_address_street__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_physical_address_street_additional__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_physical_state__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_physical_zip__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_address_section_progress__completed_EventProperties {
    is_complete: boolean;
}

interface se_signup__application_business_info_mailing_address_city__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_business_website__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_employees__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_entity_type__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_formation_date__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_industry__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_legal_name__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_ownership__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_preferred_name__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_name_section_progress__completed_EventProperties {
    is_complete: boolean;
}

interface se_signup__application_business_info_name_tax_id__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_physical_address_city__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_business_info_section_progress__completed_EventProperties {
    is_complete: boolean;
}

interface se_signup__application_dashboard_action_needed_amend_application__fired_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_action_needed_confirm_your_identity__fired_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_action_needed_confirm_your_identity__presented_EventProperties {
    is_auth_signer: boolean;
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_action_needed_correction_needed_link__fired_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_action_needed_frozen_credit__presented_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_action_needed_offer_accepted__presented_EventProperties {
    is_migration: boolean;
}

interface se_signup__application_dashboard_action_needed_offer_ready__presented_EventProperties {
    is_auth_signer: boolean;
}

interface se_signup__application_dashboard_action_needed_resend_application__fired_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_action_needed_review_and_accept_offer__fired_EventProperties {
    is_auth_signer: boolean;
}

interface se_signup__application_dashboard_action_needed_review_application_migration__presented_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_action_needed_upload_documents__fired_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_application_details_drawer_collaborator__fired_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_application_details_drawer_documents__fired_EventProperties {
    opened_from_qr_code: boolean;
}

interface se_signup__application_dashboard_documents_tab_modal__submitted_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
    se_dashboard_document_type: 'bankStatement' | 'bankVerification' | 'bpav' | 'businessRegistration' | 'driversLicense' | 'financialDocuments' | 'greencard' | 'interimFinancials' | 'other' | 'passport' | 'physicalAddressVerification' | 'ssnCard' | 'taxId' | 'usVisa';
}

interface se_signup__application_dashboard_invite_collaborator__submitted_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_invite_collaborator_delete_collaborator__submitted_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__application_dashboard_upload_documents_tab_doc_upload__submitted_EventProperties {
    person_type: 'admin' | 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
    se_dashboard_document_type: 'bankStatement' | 'bankVerification' | 'bpav' | 'businessRegistration' | 'driversLicense' | 'financialDocuments' | 'greencard' | 'interimFinancials' | 'other' | 'passport' | 'physicalAddressVerification' | 'ssnCard' | 'taxId' | 'usVisa';
}

interface se_signup__application_final_review__submitted_EventProperties {
    is_complete: boolean;
}

interface se_signup__application_financial_info_bank_connection_section_progress__completed_EventProperties {
    is_complete: boolean;
}

interface se_signup__application_financial_info_details_accountant_email__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_financial_info_details_accountant_first_name__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_financial_info_details_accountant_last_name__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_financial_info_details_acctg_software__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_financial_info_details_billing_cycle__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_financial_info_details_desired_loc__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_financial_info_details_expected_spend__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_financial_info_details_outsourced_accountant__submitted_EventProperties {
    radio_button_value: string;
}

interface se_signup__application_financial_info_details_revenue__submitted_EventProperties {
    value_present: boolean;
}

interface se_signup__application_financial_info_details_section_progress__completed_EventProperties {
    is_complete: boolean;
}

interface se_signup__application_financial_info_section_progress__completed_EventProperties {
    is_complete: boolean;
}

interface se_signup__application_offers_accept_offer__fired_EventProperties {
    offer_type: 'cash account' | 'prepay' | 'standard' | 'variable';
}

interface se_signup__application_offers_multiple_offers__presented_EventProperties {
    number_of_offers: 'number';
    offer_type: 'cash account' | 'prepay' | 'standard' | 'variable';
}

interface se_signup__application_offers_review_and_agree__fired_EventProperties {
    offer_type: 'cash account' | 'prepay' | 'standard' | 'variable';
}

interface se_signup__application_offers_view_offer_details__fired_EventProperties {
    offer_type: 'cash account' | 'prepay' | 'standard' | 'variable';
}

interface se_signup__application_offers_view_offer_summary__fired_EventProperties {
    offer_type: 'cash account' | 'prepay' | 'standard' | 'variable';
}

interface se_signup__application_people_info_section_progress__completed_EventProperties {
    is_complete: boolean;
}

interface se_signup__delete_person__fired_EventProperties {
    person_type: 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__edit_person__fired_EventProperties {
    person_type: 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__edit_person_drawer_cancelled__fired_EventProperties {
    person_type: 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__edit_person_drawer_saved__fired_EventProperties {
    person_type: 'authorizedSigner' | 'companyOwner' | 'outsourcedAccountant';
}

interface se_signup__eligible_offers__presented_EventProperties {
    number_of_offers: number;
}

interface se_signup__eligible_offers_accept_offer__fired_EventProperties {
    offer_type: 'prepay' | 'standard' | 'undefined' | 'variable';
}

interface se_signup__eligible_offers_learn_more__fired_EventProperties {
    offer_type: 'prepay' | 'standard' | 'undefined' | 'variable';
}

interface se_signup__eligible_offers_offer_tile_cta__fired_EventProperties {
    offer_type: 'prepay' | 'standard' | 'undefined' | 'variable';
}

interface se_signup__eligible_offers_tila_agreement__presented_EventProperties {
    offer_type: 'prepay' | 'standard' | 'undefined' | 'variable';
}

interface se_signup__eligible_offers_tila_agreement_agree__fired_EventProperties {
    offer_type: 'prepay' | 'standard' | 'undefined' | 'variable';
}

interface se_signup__eligible_offers_tila_agreement_cancel__fired_EventProperties {
    offer_type: 'prepay' | 'standard' | 'undefined' | 'variable';
}

interface se_signup__email_verification__submitted_EventProperties {
    button_id: string;
}

interface se_signup__email_verification_back__fired_EventProperties {
    anonymous_id: string;
    device_type: string;
    lead_id: string;
    navigated_from_page: string;
    navigated_to_page: string;
}

interface se_signup__email_verification_email_id__entered_EventProperties {
    email_field_has_value: boolean;
}

interface se_signup__error_message__fired_EventProperties {
    error_field: string;
    error_message_text: string;
}

interface se_signup__failure_get_started__triggered_EventProperties {
    get_started_window_name: string;
}

interface se_signup__left_nav_menu_section_change__fired_EventProperties {
    navigated_to_page: string;
}

interface se_signup__qualification_check_cash_balance__submitted_EventProperties {
    button_id: string;
    option_value_selected: string;
}

interface se_signup__qualification_check_credit_score__submitted_EventProperties {
    button_id: string;
    option_value_selected: string;
}

interface se_signup__qualification_check_revenue__submitted_EventProperties {
    button_id: string;
    option_value_selected: string;
}

interface se_signup__qualification_check_revenue_back__fired_EventProperties {
    anonymous_id: string;
    device_type: string;
    lead_id: string;
    navigated_from_page: string;
    navigated_to_page: string;
}

interface se_signup__review_and_sign_edit_info__fired_EventProperties {
    application_section: string;
    navigated_to_page: string;
}

interface se_signup__verification_code__submitted_EventProperties {
    button_id: string;
    button_identifier: 'ApproveBills' | 'Bulk Send' | 'Cancel' | 'Change Payment' | 'Close' | 'Closed' | 'CreateDynamicApprovalPolicy' | 'CreditCardVeridNeeded' | 'DebitCardKYC' | 'DeniedBills' | 'DeniedVendCredits' | 'DueSoonBills' | 'ExpiredDC' | 'ExpiringDC' | 'ExpiringPayment' | 'FailedPayment' | 'FixCreditCard' | 'FixUser' | 'IncompleteTransactions' | 'InstantTransferFeeExpenseAccount' | 'InvoiceDue' | 'InvoiceFinancingApplicationApproved' | 'InvoiceFinancingDocumentUploadPending' | 'InvoiceFinancingDocumentVerificationPending' | 'MFABackup' | 'NeedMfa' | 'NeedSubmitARApplication' | 'NeedSyncSetup' | 'NeoBillApprovalPolicies' | 'NeoDualControlApprovals' | 'NeoSelectCustomDimensions' | 'NetworkInvites' | 'NetworkStatusChanged' | 'NoPrimaryReceivableBank' | 'OverdueBills' | 'OverdueChecks' | 'OverdueInvoice' | 'PaymentApprovalRequired' | 'PendingBankAccountUserNominated' | 'PendingBankAccounts' | 'PendingVendorBankAccount' | 'PolicyExceptionBills' | 'PolicyExceptionVendCredits' | 'PostTransactionApproval' | 'PurposeOfUse' | 'ReadyPayBills' | 'ReceivablesFundsHeld' | 'ReimbursementsToApprove' | 'Remove and Edit' | 'ReturnedARAch' | 'ReturnedAch' | 'ReturnedChecks' | 'Save' | 'SetComplianceData' | 'SetValidAddress' | 'SubmittedARApplication' | 'SyncErrors' | 'UnableToConnect' | 'UnprocessedDocs' | 'VendorExpiredInvite' | 'VirtualCardExpired' | 'VirtualCardExpiring' | 'acknowledgeHIPAA' | 'add_card' | 'add_filter' | 'add_item' | 'back' | 'back_preview' | 'back_to_invoice' | 'back_to_item' | 'billsToApprove' | 'cancel' | 'cc_setup' | 'clear_filter' | 'close' | 'create_invoice' | 'create_invoice_empty' | 'create_invoice_webview' | 'details_back' | 'discard' | 'download' | 'edit_filter' | 'edit_invoice' | 'edit_item' | 'empty' | 'filter' | 'filter_cancel' | 'filter_clear' | 'filter_clear_payments' | 'get_it_instantly' | 'go_back' | 'inbox' | 'instant_transfer' | 'invoce_filter_clear' | 'invoice_filter' | 'invoice_list_back' | 'invoices' | 'loan_closed' | 'mark_as_paid' | 'may_be_later' | 'modal_save' | 'new_template_button' | 'no_thanks' | 'orgName' | 'overDueBills' | 'pay_me_now' | 'payments_received' | 'payments_received_filter' | 'preview_invoice' | 'print' | 'purchase_order' | 'purchase_request' | 'qualification_check_cash_balance' | 'qualification_check_credit_score' | 'qualification_check_revenue' | 'reimbursementRequests' | 'reload' | 'reload_invoices' | 'reload_payment_recevied' | 'remove' | 'review_send' | 'review_started' | 'row_mark_as_paid' | 'save' | 'save_close' | 'save_draft_button' | 'save_draft_menu' | 'save_invoice_button' | 'save_invoice_menu' | 'save_mark_as_paid' | 'select_deposit_into' | 'send_bulk_invoice' | 'send_for_approval' | 'send_invoice' | 'set_up_now' | 'setup_auto_reminders' | 'share' | 'sign_up_email_verification_continue' | 'taskPage' | 'template_dropdown_new_template_button' | 'transactionApprovals' | 'turn_on' | 'upload_documents' | 'view_details' | 'view_less' | 'view_more' | 'view_payment';
    value_present: boolean;
}

export interface WebTrackingPlan {
    'Page Viewed': Page_Viewed_EventProperties;
    'Screen Viewed': undefined;
    'beep_experiment_assigned': beep_experiment_assigned_EventProperties;
    'se_signup___application_dashboard_action_needed_review_and_resubmit_your_application__fired': undefined;
    'se_signup__add_auth_signer_as_company_owner__fired': undefined;
    'se_signup__add_people_learn_more__fired': undefined;
    'se_signup__add_person__fired': se_signup__add_person__fired_EventProperties;
    'se_signup__add_person_drawer_cancelled__fired': se_signup__add_person_drawer_cancelled__fired_EventProperties;
    'se_signup__add_person_drawer_saved__fired': se_signup__add_person_drawer_saved__fired_EventProperties;
    'se_signup__application_accepting_offer__presented': undefined;
    'se_signup__application_business_info_address__presented': undefined;
    'se_signup__application_business_info_address_back__fired': undefined;
    'se_signup__application_business_info_address_mail_address_same_as_biz_address__submitted': se_signup__application_business_info_address_mail_address_same_as_biz_address__submitted_EventProperties;
    'se_signup__application_business_info_address_mailing_address_stree__submitted': se_signup__application_business_info_address_mailing_address_stree__submitted_EventProperties;
    'se_signup__application_business_info_address_mailing_address_street__submitted': se_signup__application_business_info_address_mailing_address_street__submitted_EventProperties;
    'se_signup__application_business_info_address_mailing_address_street_additional__submitted': se_signup__application_business_info_address_mailing_address_street_additional__submitted_EventProperties;
    'se_signup__application_business_info_address_mailing_state__submitted': se_signup__application_business_info_address_mailing_state__submitted_EventProperties;
    'se_signup__application_business_info_address_mailing_zip__submitted': se_signup__application_business_info_address_mailing_zip__submitted_EventProperties;
    'se_signup__application_business_info_address_next__fired': undefined;
    'se_signup__application_business_info_address_physical_address_street__submitted': se_signup__application_business_info_address_physical_address_street__submitted_EventProperties;
    'se_signup__application_business_info_address_physical_address_street_additional__submitted': se_signup__application_business_info_address_physical_address_street_additional__submitted_EventProperties;
    'se_signup__application_business_info_address_physical_state__submitted': se_signup__application_business_info_address_physical_state__submitted_EventProperties;
    'se_signup__application_business_info_address_physical_zip__submitted': se_signup__application_business_info_address_physical_zip__submitted_EventProperties;
    'se_signup__application_business_info_address_section_progress__completed': se_signup__application_business_info_address_section_progress__completed_EventProperties;
    'se_signup__application_business_info_mailing_address_city__submitted': se_signup__application_business_info_mailing_address_city__submitted_EventProperties;
    'se_signup__application_business_info_name__presented': undefined;
    'se_signup__application_business_info_name_business_website__submitted': se_signup__application_business_info_name_business_website__submitted_EventProperties;
    'se_signup__application_business_info_name_employees__submitted': se_signup__application_business_info_name_employees__submitted_EventProperties;
    'se_signup__application_business_info_name_entity_type__submitted': se_signup__application_business_info_name_entity_type__submitted_EventProperties;
    'se_signup__application_business_info_name_formation_date__submitted': se_signup__application_business_info_name_formation_date__submitted_EventProperties;
    'se_signup__application_business_info_name_formation_date_info__fired': undefined;
    'se_signup__application_business_info_name_industry__submitted': se_signup__application_business_info_name_industry__submitted_EventProperties;
    'se_signup__application_business_info_name_legal_name__submitted': se_signup__application_business_info_name_legal_name__submitted_EventProperties;
    'se_signup__application_business_info_name_next__fired': undefined;
    'se_signup__application_business_info_name_ownership__submitted': se_signup__application_business_info_name_ownership__submitted_EventProperties;
    'se_signup__application_business_info_name_preferred_name__submitted': se_signup__application_business_info_name_preferred_name__submitted_EventProperties;
    'se_signup__application_business_info_name_section_progress__completed': se_signup__application_business_info_name_section_progress__completed_EventProperties;
    'se_signup__application_business_info_name_tax_id__submitted': se_signup__application_business_info_name_tax_id__submitted_EventProperties;
    'se_signup__application_business_info_physical_address_city__submitted': se_signup__application_business_info_physical_address_city__submitted_EventProperties;
    'se_signup__application_business_info_section_progress__completed': se_signup__application_business_info_section_progress__completed_EventProperties;
    'se_signup__application_dashboard__presented': undefined;
    'se_signup__application_dashboard_action_needed_account_created__presented': undefined;
    'se_signup__application_dashboard_action_needed_amend_application__fired': se_signup__application_dashboard_action_needed_amend_application__fired_EventProperties;
    'se_signup__application_dashboard_action_needed_awaiting_signature__presented': undefined;
    'se_signup__application_dashboard_action_needed_confirm_your_identity__fired': se_signup__application_dashboard_action_needed_confirm_your_identity__fired_EventProperties;
    'se_signup__application_dashboard_action_needed_confirm_your_identity__presented': se_signup__application_dashboard_action_needed_confirm_your_identity__presented_EventProperties;
    'se_signup__application_dashboard_action_needed_correction_needed__presented': undefined;
    'se_signup__application_dashboard_action_needed_correction_needed_link__fired': se_signup__application_dashboard_action_needed_correction_needed_link__fired_EventProperties;
    'se_signup__application_dashboard_action_needed_frozen_credit__presented': se_signup__application_dashboard_action_needed_frozen_credit__presented_EventProperties;
    'se_signup__application_dashboard_action_needed_log_in__fired': undefined;
    'se_signup__application_dashboard_action_needed_offer_accepted__presented': se_signup__application_dashboard_action_needed_offer_accepted__presented_EventProperties;
    'se_signup__application_dashboard_action_needed_offer_ready__presented': se_signup__application_dashboard_action_needed_offer_ready__presented_EventProperties;
    'se_signup__application_dashboard_action_needed_refresh_application__presented': undefined;
    'se_signup__application_dashboard_action_needed_refresh_to_continue__fired': undefined;
    'se_signup__application_dashboard_action_needed_request_review__fired': undefined;
    'se_signup__application_dashboard_action_needed_resend_application__fired': se_signup__application_dashboard_action_needed_resend_application__fired_EventProperties;
    'se_signup__application_dashboard_action_needed_resubmit_application__fired': undefined;
    'se_signup__application_dashboard_action_needed_resume_application__presented': undefined;
    'se_signup__application_dashboard_action_needed_resume_your_application__fired': undefined;
    'se_signup__application_dashboard_action_needed_review_and_accept_offer__fired': se_signup__application_dashboard_action_needed_review_and_accept_offer__fired_EventProperties;
    'se_signup__application_dashboard_action_needed_review_and_send_to_signer__fired': undefined;
    'se_signup__application_dashboard_action_needed_review_application_migration__presented': se_signup__application_dashboard_action_needed_review_application_migration__presented_EventProperties;
    'se_signup__application_dashboard_action_needed_review_offer__fired': undefined;
    'se_signup__application_dashboard_action_needed_set_up_login__fired': undefined;
    'se_signup__application_dashboard_action_needed_upload_documents__fired': se_signup__application_dashboard_action_needed_upload_documents__fired_EventProperties;
    'se_signup__application_dashboard_action_needed_upload_documents__presented': undefined;
    'se_signup__application_dashboard_application_details_drawer_close__fired': undefined;
    'se_signup__application_dashboard_application_details_drawer_collaborator__fired': se_signup__application_dashboard_application_details_drawer_collaborator__fired_EventProperties;
    'se_signup__application_dashboard_application_details_drawer_documents__fired': se_signup__application_dashboard_application_details_drawer_documents__fired_EventProperties;
    'se_signup__application_dashboard_application_details_tab_drawer__fired': undefined;
    'se_signup__application_dashboard_documents_tab__closed': undefined;
    'se_signup__application_dashboard_documents_tab_modal__cancelled': undefined;
    'se_signup__application_dashboard_documents_tab_modal__submitted': se_signup__application_dashboard_documents_tab_modal__submitted_EventProperties;
    'se_signup__application_dashboard_documents_tab_modal_file_item__fired': undefined;
    'se_signup__application_dashboard_documents_tab_upload_doc__started': undefined;
    'se_signup__application_dashboard_home_action_needed_tab__fired': undefined;
    'se_signup__application_dashboard_home_all_tab__fired': undefined;
    'se_signup__application_dashboard_home_ap_home__fired': undefined;
    'se_signup__application_dashboard_home_ap_home__presented': undefined;
    'se_signup__application_dashboard_home_completed_tab__fired': undefined;
    'se_signup__application_dashboard_home_help_center_link__fired': undefined;
    'se_signup__application_dashboard_home_help_link__fired': undefined;
    'se_signup__application_dashboard_home_in_review_tab__fired': undefined;
    'se_signup__application_dashboard_home_legal_link__fired': undefined;
    'se_signup__application_dashboard_home_log_in_here_link__fired': undefined;
    'se_signup__application_dashboard_home_log_out__fired': undefined;
    'se_signup__application_dashboard_home_new_application__fired': undefined;
    'se_signup__application_dashboard_home_privacy_link__fired': undefined;
    'se_signup__application_dashboard_home_security_link__fired': undefined;
    'se_signup__application_dashboard_home_view_details__fired': undefined;
    'se_signup__application_dashboard_invite_collaborator__submitted': se_signup__application_dashboard_invite_collaborator__submitted_EventProperties;
    'se_signup__application_dashboard_invite_collaborator_cancel__fired': undefined;
    'se_signup__application_dashboard_invite_collaborator_delete_collaborator__submitted': se_signup__application_dashboard_invite_collaborator_delete_collaborator__submitted_EventProperties;
    'se_signup__application_dashboard_upload_documents_error_banner__presented': undefined;
    'se_signup__application_dashboard_upload_documents_tab_doc_upload__submitted': se_signup__application_dashboard_upload_documents_tab_doc_upload__submitted_EventProperties;
    'se_signup__application_experian_modal__presented': undefined;
    'se_signup__application_experian_modal_go_to_experian__fired': undefined;
    'se_signup__application_experian_modal_learn_more__fired': undefined;
    'se_signup__application_experian_modal_security_freeze_center__fired': undefined;
    'se_signup__application_final_review__submitted': se_signup__application_final_review__submitted_EventProperties;
    'se_signup__application_financial_info_bank_connection__succeeded': undefined;
    'se_signup__application_financial_info_bank_connection_back__submitted': undefined;
    'se_signup__application_financial_info_bank_connection_next__submitted': undefined;
    'se_signup__application_financial_info_bank_connection_section_progress__completed': se_signup__application_financial_info_bank_connection_section_progress__completed_EventProperties;
    'se_signup__application_financial_info_connect_bank__presented': undefined;
    'se_signup__application_financial_info_connect_manual_delete_bank__fired': undefined;
    'se_signup__application_financial_info_connect_manually__submitted': undefined;
    'se_signup__application_financial_info_connect_manually_add_account__cancelled': undefined;
    'se_signup__application_financial_info_connect_manually_add_account__submitted': undefined;
    'se_signup__application_financial_info_connect_mx__closed': undefined;
    'se_signup__application_financial_info_connect_mx__submitted': undefined;
    'se_signup__application_financial_info_connect_mx_continue__submitted': undefined;
    'se_signup__application_financial_info_connect_mx_delete_connection__fired': undefined;
    'se_signup__application_financial_info_details__presented': undefined;
    'se_signup__application_financial_info_details_accountant_email__submitted': se_signup__application_financial_info_details_accountant_email__submitted_EventProperties;
    'se_signup__application_financial_info_details_accountant_first_name__submitted': se_signup__application_financial_info_details_accountant_first_name__submitted_EventProperties;
    'se_signup__application_financial_info_details_accountant_last_name__submitted': se_signup__application_financial_info_details_accountant_last_name__submitted_EventProperties;
    'se_signup__application_financial_info_details_acctg_software__submitted': se_signup__application_financial_info_details_acctg_software__submitted_EventProperties;
    'se_signup__application_financial_info_details_back__fired': undefined;
    'se_signup__application_financial_info_details_billing_cycle__submitted': se_signup__application_financial_info_details_billing_cycle__submitted_EventProperties;
    'se_signup__application_financial_info_details_desired_loc__submitted': se_signup__application_financial_info_details_desired_loc__submitted_EventProperties;
    'se_signup__application_financial_info_details_expected_spend__submitted': se_signup__application_financial_info_details_expected_spend__submitted_EventProperties;
    'se_signup__application_financial_info_details_next__fired': undefined;
    'se_signup__application_financial_info_details_outsourced_accountant__submitted': se_signup__application_financial_info_details_outsourced_accountant__submitted_EventProperties;
    'se_signup__application_financial_info_details_revenue__submitted': se_signup__application_financial_info_details_revenue__submitted_EventProperties;
    'se_signup__application_financial_info_details_section_progress__completed': se_signup__application_financial_info_details_section_progress__completed_EventProperties;
    'se_signup__application_financial_info_section_progress__completed': se_signup__application_financial_info_section_progress__completed_EventProperties;
    'se_signup__application_frozen_credit__presented': undefined;
    'se_signup__application_how_to_lift_credit_freeze__fired': undefined;
    'se_signup__application_migration_success__presented': undefined;
    'se_signup__application_migration_success_go_to_dashboard__fired': undefined;
    'se_signup__application_migration_success_logout__fired': undefined;
    'se_signup__application_no_uw_offer_xsell_get_started__fired': undefined;
    'se_signup__application_offers_accept_offer__fired': se_signup__application_offers_accept_offer__fired_EventProperties;
    'se_signup__application_offers_ach_authorization__fired': undefined;
    'se_signup__application_offers_credit_terms__fired': undefined;
    'se_signup__application_offers_fcra_terms__fired': undefined;
    'se_signup__application_offers_learn_more__fired': undefined;
    'se_signup__application_offers_multiple_offers__presented': se_signup__application_offers_multiple_offers__presented_EventProperties;
    'se_signup__application_offers_offer_summary_agree__fired': undefined;
    'se_signup__application_offers_offer_summary_cancel__fired': undefined;
    'se_signup__application_offers_previous__fired': undefined;
    'se_signup__application_offers_privacy_policy__fired': undefined;
    'se_signup__application_offers_review_and_agree__fired': se_signup__application_offers_review_and_agree__fired_EventProperties;
    'se_signup__application_offers_terms_and_conditions__fired': undefined;
    'se_signup__application_offers_tila_agreement__presented': undefined;
    'se_signup__application_offers_view_offer_details__fired': se_signup__application_offers_view_offer_details__fired_EventProperties;
    'se_signup__application_offers_view_offer_summary__fired': se_signup__application_offers_view_offer_summary__fired_EventProperties;
    'se_signup__application_people_info_back__fired': undefined;
    'se_signup__application_people_info_next__fired': undefined;
    'se_signup__application_people_info_section_progress__completed': se_signup__application_people_info_section_progress__completed_EventProperties;
    'se_signup__application_submission_error__presented': undefined;
    'se_signup__application_submission_error_contact_support__fired': undefined;
    'se_signup__application_submission_error_go_to_dashboard__fired': undefined;
    'se_signup__application_v2_get_to_know__submitted': undefined;
    'se_signup__application_v2_good_fit__submitted': undefined;
    'se_signup__application_v2_login_business_email__submitted': undefined;
    'se_signup__application_v2_login_verification_code__submitted': undefined;
    'se_signup__application_v2_review_and_sign__submitted': undefined;
    'se_signup__application_v2_start_credit_application__submitted': undefined;
    'se_signup__application_working_out_details__presented': undefined;
    'se_signup__application_working_out_details_go_to_dashboard__fired': undefined;
    'se_signup__application_working_out_details_logout__fired': undefined;
    'se_signup__browser_back__fired': undefined;
    'se_signup__delete_person__fired': se_signup__delete_person__fired_EventProperties;
    'se_signup__edit_person__fired': se_signup__edit_person__fired_EventProperties;
    'se_signup__edit_person_drawer_cancelled__fired': se_signup__edit_person_drawer_cancelled__fired_EventProperties;
    'se_signup__edit_person_drawer_saved__fired': se_signup__edit_person_drawer_saved__fired_EventProperties;
    'se_signup__eligible_offers__presented': se_signup__eligible_offers__presented_EventProperties;
    'se_signup__eligible_offers_accept_offer__fired': se_signup__eligible_offers_accept_offer__fired_EventProperties;
    'se_signup__eligible_offers_accepting_offer_polling__presented': undefined;
    'se_signup__eligible_offers_ach_authorization__fired': undefined;
    'se_signup__eligible_offers_credit_terms__fired': undefined;
    'se_signup__eligible_offers_learn_more__fired': se_signup__eligible_offers_learn_more__fired_EventProperties;
    'se_signup__eligible_offers_offer_terms_checkbox__fired': undefined;
    'se_signup__eligible_offers_offer_tile_cta__fired': se_signup__eligible_offers_offer_tile_cta__fired_EventProperties;
    'se_signup__eligible_offers_privacy_policy__fired': undefined;
    'se_signup__eligible_offers_terms_and_conditions__fired': undefined;
    'se_signup__eligible_offers_tila_agreement__presented': se_signup__eligible_offers_tila_agreement__presented_EventProperties;
    'se_signup__eligible_offers_tila_agreement_agree__fired': se_signup__eligible_offers_tila_agreement_agree__fired_EventProperties;
    'se_signup__eligible_offers_tila_agreement_cancel__fired': se_signup__eligible_offers_tila_agreement_cancel__fired_EventProperties;
    'se_signup__email_verification__presented': undefined;
    'se_signup__email_verification__submitted': se_signup__email_verification__submitted_EventProperties;
    'se_signup__email_verification_back__fired': se_signup__email_verification_back__fired_EventProperties;
    'se_signup__email_verification_email_id__entered': se_signup__email_verification_email_id__entered_EventProperties;
    'se_signup__email_verification_sign_in__submitted': undefined;
    'se_signup__error_message__fired': se_signup__error_message__fired_EventProperties;
    'se_signup__failure_get_started__triggered': se_signup__failure_get_started__triggered_EventProperties;
    'se_signup__frozen_credit_go_to_dashboard__fired': undefined;
    'se_signup__go_to_dashboard__fired': undefined;
    'se_signup__good_fit_failed__presented': undefined;
    'se_signup__good_fit_success__presented': undefined;
    'se_signup__good_fit_success_lets_go__submitted': undefined;
    'se_signup__has__completed': undefined;
    'se_signup__has__started': undefined;
    'se_signup__left_nav_invite_collaborator__fired': undefined;
    'se_signup__left_nav_menu_section_change__fired': se_signup__left_nav_menu_section_change__fired_EventProperties;
    'se_signup__left_nav_save_and_exit__fired': undefined;
    'se_signup__no_offer__presented': undefined;
    'se_signup__people_info__presented': undefined;
    'se_signup__privacy_policy__fired': undefined;
    'se_signup__processing_application__presented': undefined;
    'se_signup__qualification_check_cash_balance__presented': undefined;
    'se_signup__qualification_check_cash_balance__submitted': se_signup__qualification_check_cash_balance__submitted_EventProperties;
    'se_signup__qualification_check_cash_balance_back__fired': undefined;
    'se_signup__qualification_check_cash_balance_next__fired': undefined;
    'se_signup__qualification_check_credit_score__presented': undefined;
    'se_signup__qualification_check_credit_score__submitted': se_signup__qualification_check_credit_score__submitted_EventProperties;
    'se_signup__qualification_check_credit_score_back__fired': undefined;
    'se_signup__qualification_check_credit_score_submit__fired': undefined;
    'se_signup__qualification_check_revenue__presented': undefined;
    'se_signup__qualification_check_revenue__submitted': se_signup__qualification_check_revenue__submitted_EventProperties;
    'se_signup__qualification_check_revenue_back__fired': se_signup__qualification_check_revenue_back__fired_EventProperties;
    'se_signup__qualification_check_revenue_next__fired': undefined;
    'se_signup__review_and_sign__presented': undefined;
    'se_signup__review_and_sign__submitted': undefined;
    'se_signup__review_and_sign_edit_info__fired': se_signup__review_and_sign_edit_info__fired_EventProperties;
    'se_signup__terms_and_conditions__fired': undefined;
    'se_signup__terms_and_services__fired': undefined;
    'se_signup__upload_from_your_phone__fired': undefined;
    'se_signup__v2_application_dashboard_documents_needed_tile__presented': undefined;
    'se_signup__v2_application_dashboard_upload_documents__fired': undefined;
    'se_signup__verification_code__submitted': se_signup__verification_code__submitted_EventProperties;
    'se_signup__verification_code_resend__submitted': undefined;
    'se_signup__verification_code_screen__presented': undefined;
}

export interface system_properties {
    _app_framework_name?: string;
    _app_framework_version?: string;
    _app_host_name: string;
    _app_host_version: string;
    _bdc_login_id?: string;
    _bdc_org_id?: string;
    _bdc_user_id?: string;
    _divvy_credential_uuid?: string;
    _divvy_org_user_uuid?: string;
    _divvy_org_uuid?: string;
    _ent_login_id?: string;
    _ent_org_id?: string;
    _ent_org_user_id?: string;
    _fs_session_url?: string;
    _is_anonymous?: boolean;
    _partner_type?: string;
    _project_id: number;
}

export interface identify__traits__assigned {
    _bdc_login_id?: string;
    _bdc_org_id?: string;
    _bdc_user_id?: string;
    _divvy_credential_uuid?: string;
    _divvy_org_user_uuid?: string;
    _divvy_org_uuid?: string;
    _ent_login_id?: string;
    _ent_org_id?: string;
    _ent_org_user_id?: string;
    _is_cj_context?: boolean;
    _is_me_context?: boolean;
    _op_user_id?: string;
    address_country?: string;
    address_zipcode?: string;
    anonymous_id?: string;
    business_type?: string;
    email?: string;
    first_name?: string;
    is_ops_user?: boolean;
    last_name?: string;
    signup_source?: string;
    user_role?: string;
}

export interface group__traits__assigned {
    _bdc_login_id?: string;
    _bdc_org_id?: string;
    _bdc_user_id?: string;
    _divvy_credential_uuid?: string;
    _divvy_org_user_uuid?: string;
    _divvy_org_uuid?: string;
    _ent_login_id?: string;
    _ent_org_id?: string;
    _ent_org_user_id?: string;
    account_type?: string;
    accounting_software?: string;
    business_category?: string;
    business_channel?: number;
    can_pay_anyone?: boolean;
    can_receive_from_anyone?: boolean;
    client_org_id?: string;
    is_advanced_org?: boolean;
    is_basic_org?: boolean;
    is_enabled_ap?: boolean;
    is_enabled_ar?: boolean;
    is_enabled_bp?: boolean;
    is_enabled_br?: boolean;
    is_insights?: boolean;
    is_international?: boolean;
    is_shell_org?: boolean;
    is_trial_ended?: boolean;
    is_up_org?: boolean;
    is_wealth_management_console?: boolean;
    org_payment_status?: string;
    org_status?: string;
    organization_name?: string;
    partner_type?: string;
    signup_source?: string;
}
export type SystemProperties = { [K in keyof system_properties]: system_properties[K] };
export type IdentifyProps = Omit<identify__traits__assigned, keyof system_properties> & Partial<Pick<system_properties, keyof system_properties>>;
export type GroupProps = Omit<group__traits__assigned, keyof system_properties> & Partial<Pick<system_properties, keyof system_properties>>;

export const createTypedTracker = createTracker<WebTrackingPlan, SystemProperties, IdentifyProps, GroupProps>;

export type HostTracker = HostWebTracker<WebTrackingPlan, SystemProperties, IdentifyProps, GroupProps>;
export type MfeTracker = MFEWebTracker<WebTrackingPlan, IdentifyProps, GroupProps>;